module.exports = __webpack_public_path__ + "media/icons/numer_vin-2073233d.png";